import { Injectable } from '@angular/core';
import { map } from 'rxjs';
import { BaseService } from 'src/app/_services/base.service';
import { environment } from 'src/environments/environment';

@Injectable({
    providedIn: 'root'
})
export class MerchantPayoutReportService {

    constructor(private _bs: BaseService) { }

    getMerchantPayoutReportList(model?: any) {
        const url = environment.InventoryBaseURLSTG + 'MerchantPayoutReport';
        return this._bs.httpGetParams(url, model).pipe(map((res: any) => {
            return res;
        }));
    }

    getMerchantPayoutReportSummary(model?: any) {
        const url = environment.InventoryBaseURLSTG + 'MerchantPayoutReportSummary';
        return this._bs.httpGetParams(url, model).pipe(map((res: any) => {
            return res;
        }));
    }
}
